"use client";
import { useMediaQuery } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { signIn, useSession } from "next-auth/react";
import { useTranslation } from "@/app/i18n/client";
import esp_flag from "@/assets/images/icons/esp_flag.svg";
import uk_flag from "@/assets/images/icons/uk_flag.svg";
import vee_logo_large from "@/assets/images/logos/vee-logo-png.png";
import HexagonButton from "@/common/customElements/HexagonButton";
import { InlineDiv, VerticalCenterDiv } from "@/common/divs";
import { TextLink } from "@/common/texts";
import { ProfileButton } from "@/components/layout/header/profileButton";
import { NEUTRO_TITLES_COLOR, PRIMARY_BUTTON_COLOR } from "@/utils/constants";
import routes from "@/utils/routes.json";

const HeaderAnonLayout: React.FC = () => {
  const { data: session } = useSession();
  const { t, i18n } = useTranslation();
  const router = useRouter();
  const isMobile = useMediaQuery("(max-width: 930px)");

  return (
    <header>
      <InlineDiv
        className="responsiveHeader"
        width="100%"
        height="80px"
        background={NEUTRO_TITLES_COLOR}
        paddingX="108px"
      >
        <VerticalCenterDiv className="responsiveHeader">
          <Link
            href="/home"
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <Image
              src={vee_logo_large}
              alt="logo"
              width={123}
              height={46}
              className="h-auto"
              priority={true}
              quality={100}
            />
          </Link>
        </VerticalCenterDiv>
        <VerticalCenterDiv
          className="hideOnResponsive"
          right="108px"
          style={{ display: "flex", gap: "16px", alignItems: "center" }}
        >
          {routes.map((route, index) => {
            return (
              <Link
                href={
                  i18n.language == "en" ? route["en-route"] : route["es-route"]
                }
                key={index}
              >
                <TextLink>{t(route.i18_tag)}</TextLink>
              </Link>
            );
          })}
          <InlineDiv>
            <HexagonButton
              width="35pX"
              marginX="5px"
              backgroundColor={PRIMARY_BUTTON_COLOR}
              onClick={() => {
                router.push("/es/");
              }}
            >
              {" "}
              <Image
                alt="spain"
                width="18"
                height="12"
                src={esp_flag.src}
                style={{
                  position: "absolute",
                  top: "30%",
                  left: "24%",
                  height: "12px",
                  width: "18px",
                }}
              />
            </HexagonButton>
            <HexagonButton
              width="35pX"
              marginX="5px"
              backgroundColor={PRIMARY_BUTTON_COLOR}
              onClick={() => {
                router.push("/en/");
              }}
            >
              {" "}
              <Image
                alt="uk"
                width="18"
                height="12"
                src={uk_flag.src}
                style={{
                  position: "absolute",
                  top: "30%",
                  left: "24%",
                  height: "12px",
                  width: "18px",
                }}
              />
            </HexagonButton>
          </InlineDiv>
          {session?.user ?
            <ProfileButton />
          : <TextLink
              onClick={() => {
                signIn();
              }}
            >
              {t("first_entry.login")}
            </TextLink>
          }
        </VerticalCenterDiv>
        {isMobile && (
          <VerticalCenterDiv style={{ right: "0" }}>
            {session?.user ?
              <ProfileButton />
            : <TextLink
                onClick={() => {
                  signIn();
                }}
              >
                {t("first_entry.login")}
              </TextLink>
            }
          </VerticalCenterDiv>
        )}
      </InlineDiv>
    </header>
  );
};

export default HeaderAnonLayout;
